/**
 * The one category tab bar (Frames · Covers · Bases …) used by every page, each tab with its part count.
 * `right` sits at the end of the bar (e.g. the March Products / Gold Crest switch on Monitor).
 */
import type { ReactNode } from "react";

export function CategoryTabs<T extends string>({
  items, value, onChange, label, counts, loading, right,
}: {
  items: readonly T[];
  value: T;
  onChange: (v: T) => void;
  label: (v: T) => string;
  counts?: Partial<Record<T, number>>;
  loading?: boolean;
  right?: ReactNode;
}) {
  return (
    <div className="tabs-row">
      <div className="tabs" role="tablist">
        {items.map((x) => (
          <button key={x} type="button" role="tab" aria-selected={value === x} className={`tab${value === x ? " on" : ""}`} onClick={() => onChange(x)}>
            {label(x)}
            {counts && <span className="n">{loading ? "…" : counts[x] ?? 0}</span>}
          </button>
        ))}
      </div>
      {right && <div className="tabs-right">{right}</div>}
    </div>
  );
}
